<template>
  <div class="ll-quiz-ques-with-title__container">
    <div
      class="ll-quiz-ques-with-title"
      :class="{red:warningText}"
    >
      <WsText001
        v-if="index"
        h3
        bold
        class="ll-quiz-ques-with-title__index mr-8"
      >
        {{ index }}.
      </WsText001>
      <WsCol>
        <WsText001
          v-if="title"
          h3
          bold
        >
          {{ $t(title) }}
        </WsText001>
        <WsText001
          v-if="subtitle"
          h4
          class="mt-8"
          style="white-space: pre-line"
        >
          {{ $t(subtitle) }}
        </WsText001>
        <WsTextChip001
          v-if="warningText"
          red
          icon-lg
          leading-icon="icon-warning-filled"
          :text-label="warningText"
          class="mt-8"
        />
      </WsCol>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlQuizQuestionListWithTitle",
  props: {
    warningText: {
      type: String,
      default: "",
    },
    index: {
      type: String,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
  },
};
</script>
 <style lang="scss">
@import "@/assets/scss/component/ll-quiz-question-with-title";
</style>